import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { patchImageSlider } from 'redux/image-sliders/actions';

import { Checkbox } from 'semantic-ui-react';

import CommonTextInput from
  'components/elements/inputs/CommonTextInput';

import './ImageSliderDescription.css';

const ImageSliderDescription = props => {
  const { item, patchImageSlider, patchImageSliderError } = props;
  const { t } = useTranslation();

  const onCheckboxChange = (_e, { checked }) => {
    const form = new FormData();
    form.append('description_is_active', checked);
    patchImageSlider(item.id, form);
  };

  const changeValue = (parameter, value) => {
    const form = new FormData();
    form.append(parameter, value);
    patchImageSlider(item.id, form);
  };

  const titleValidation = value => {
    const errors = [];
    if (value && value.length > 128) {
      errors.push(t("Ensure this field has no more than 128 characters"));
    }
    return errors;
  };

  const descriptionValidation = value => {
    const errors = [];
    if (value && value.length > 128) {
      errors.push(t("Ensure this field has no more than 128 characters"));
    }
    return errors;
  };

  return (
    <div className="image-slider-description__component">
      <div className="header">
        <div className="label">{t("Add Description")}</div>
        <div className="checkbox-wrapper">
          <div className="option">{t("OFF")}</div>
          <Checkbox
            toggle
            checked={item.description_is_active}
            onChange={onCheckboxChange}
          />
          <div className="option">{t("ON")}</div>
        </div>
      </div>

      {/* Content */}
      {item.description_is_active &&
        <div className="content">
          {/* Title */}
          <CommonTextInput
            key={`image-slider-description-title-input-key-${item.id}`}
            label={t("Title")}
            placeholder={t("Image Slider Title")}
            initValue={item.title}
            executedFunction={value => { changeValue('title', value); }}
            validationErrors={value => { return titleValidation(value); }}
            actionErrors={patchImageSliderError && patchImageSliderError.title}
          />

          {/* Description */}
          <CommonTextInput
            key={`image-slider-description-descr-input-key-${item.id}`}
            label={t("Description")}
            placeholder={t("Image Slider Description")}
            initValue={item.description}
            executedFunction={value => { changeValue('description', value); }}
            validationErrors={value => { return descriptionValidation(value); }}
            actionErrors={patchImageSliderError && patchImageSliderError.description}
          />
        </div>
      }
    </div>
  );
};

ImageSliderDescription.propTypes = {
  patchImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  patchImageSliderError: PropTypes.object,
};

ImageSliderDescription.defaultProps = {
  patchImageSliderError: null,
};

const mapStateToProps = state => (
  {
    patchImageSliderError: state.imageSlidersReducer.patchImageSliderError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchImageSlider,
  },
)(ImageSliderDescription);
